import { Howl } from 'howler';

import snare from '~/images/pages/dnsound/drums/snare.mp3';
import hat from '~/images/pages/dnsound/drums/hat.mp3';
import kick from '~/images/pages/dnsound/drums/kick.mp3';

import ohyeah from '~/images/pages/dnsound/vocals/oh-yeah-dot-sexy.mp3';
import rainbow from '~/images/pages/dnsound/vocals/rainbow-catpaws.mp3';

import bassA from '~/images/pages/dnsound/bass/a.mp3';
import bassAaaa from '~/images/pages/dnsound/bass/aaaa.mp3';
import bassAlias from '~/images/pages/dnsound/bass/alias.mp3';
import bassCname from '~/images/pages/dnsound/bass/cname.mp3';
import bassMx from '~/images/pages/dnsound/bass/mx.mp3';
import bassNs from '~/images/pages/dnsound/bass/ns.mp3';
import bassSoa from '~/images/pages/dnsound/bass/soa.mp3';
import bassSpf from '~/images/pages/dnsound/bass/spf.mp3';
import bassTxt from '~/images/pages/dnsound/bass/txt.mp3';

import midsA from '~/images/pages/dnsound/mids/a.mp3';
import midsAaaa from '~/images/pages/dnsound/mids/aaaa.mp3';
import midsAlias from '~/images/pages/dnsound/mids/alias.mp3';
import midsCname from '~/images/pages/dnsound/mids/cname.mp3';
import midsMx from '~/images/pages/dnsound/mids/mx.mp3';
import midsNs from '~/images/pages/dnsound/mids/ns.mp3';
import midsSoa from '~/images/pages/dnsound/mids/soa.mp3';
import midsSpf from '~/images/pages/dnsound/mids/spf.mp3';
import midsTxt from '~/images/pages/dnsound/mids/txt.mp3';

import highsA from '~/images/pages/dnsound/highs/a.mp3';
import highsAaaa from '~/images/pages/dnsound/highs/aaaa.mp3';
import highsAlias from '~/images/pages/dnsound/highs/alias.mp3';
import highsCname from '~/images/pages/dnsound/highs/cname.mp3';
import highsMx from '~/images/pages/dnsound/highs/mx.mp3';
import highsNs from '~/images/pages/dnsound/highs/ns.mp3';
import highsSoa from '~/images/pages/dnsound/highs/soa.mp3';
import highsSpf from '~/images/pages/dnsound/highs/spf.mp3';
import highsTxt from '~/images/pages/dnsound/highs/txt.mp3';

export class Sounds {
  loadBass () {
    const a = new Howl({ src: bassA });
    const aaaa = new Howl({ src: bassAaaa });
    const alias = new Howl({ src: bassAlias });
    const cname = new Howl({ src: bassCname });
    const mx = new Howl({ src: bassMx });
    const ns = new Howl({ src: bassNs });
    const soa = new Howl({ src: bassSoa });
    const spf = new Howl({ src: bassSpf });
    const txt = new Howl({ src: bassTxt });
    return { a, aaaa, alias, cname, mx, ns, soa, spf, txt };
  }

  loadMids () {
    const a = new Howl({ src: midsA });
    const aaaa = new Howl({ src: midsAaaa });
    const alias = new Howl({ src: midsAlias });
    const cname = new Howl({ src: midsCname });
    const mx = new Howl({ src: midsMx });
    const ns = new Howl({ src: midsNs });
    const soa = new Howl({ src: midsSoa });
    const spf = new Howl({ src: midsSpf });
    const txt = new Howl({ src: midsTxt });
    return { a, aaaa, alias, cname, mx, ns, soa, spf, txt };
  }

  loadHighs () {
    const a = new Howl({ src: highsA });
    const aaaa = new Howl({ src: highsAaaa });
    const alias = new Howl({ src: highsAlias });
    const cname = new Howl({ src: highsCname });
    const mx = new Howl({ src: highsMx });
    const ns = new Howl({ src: highsNs });
    const soa = new Howl({ src: highsSoa });
    const spf = new Howl({ src: highsSpf });
    const txt = new Howl({ src: highsTxt });
    return { a, aaaa, alias, cname, mx, ns, soa, spf, txt };
  }

  loadDrums () {
    const k = new Howl({ src: kick });
    const s = new Howl({ src: snare });
    const h = new Howl({ src: hat });
    return { k, s, h };
  }

  loadVocals () {
    const o = new Howl({ src: ohyeah });
    const r = new Howl({ src: rainbow });
    return { o, r };
  }
};

export default Sounds;
